// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Lazyload from 'vue-lazyload'
import {cdnFn} from 'src/common/Fn'
import { each, map, get } from 'lodash'

import 'element-ui/lib/theme-chalk/index.css'
import '../html/less/common/style.less'
import 'vueditor/dist/style/vueditor.min.css'

import './icons' // icon
import './errorLog'// error log
import './permission' // permission control

import './directive'
import RavenConfig from './config/raven.config'
import ElementUI from 'element-ui'
import router from './router/index'
import store from './store/index'
import VueBus from 'vue-bus'
import 'src/views/Component/index'
import Vueditor from 'vueditor';
import {editorConfig} from 'src/config/config'

import i18n from './lang' // Internationalization
import './errorLog'// error log
import './mock/index' // simulation data
import Echarts from 'echarts'
import * as filters from './filters' // global filters
// register global utility filters.
each(filters, (value, key)=>{
  Vue.filter(key, value)
})
Vue.prototype.$echarts = Echarts;
Vue.use(Lazyload, {
  preLoad: 2,
  filter: {
    progressive (listener, options) {
      let el  = listener.el;
      let {
        width,
        height
      } = el;
      [width, height] = map([width, height], function (item) {
        if (item && item > 0) {
          return item;
        }
        return 0;
      });
      let def = '/quality/90/compress/true/progressive/true/strip/false/exifswitch/false/rotate/auto/both/';
      let format = get(el, 'dataset.format');
      if( cdnFn && format ) {
        if (/^[\d ]+$/.test(format)) {
          format = map(format.split(' '), item => parseInt(item));
          width = get(format, 0);
          height = get(format, 1) || width;
          format = `${def}${width}x${height}`;
        }
      }
      if (!format && width && height) {
        format = `${def}${width}x${height}`;
      }
      if (cdnFn && format) {
        listener.src = cdnFn(listener.src, format);
      }
    }
  }
});

Vue.use(ElementUI,  {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(VueBus)
Vue.use(Vueditor, editorConfig);
RavenConfig();

// 设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  store
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js